module.exports = __webpack_public_path__ + "img/window-restore.22d94a41.svg";